module.exports = __webpack_public_path__ + "img/teen.b93ab68c.svg";